var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogFormDialog',{ref:"dialog",attrs:{"strings":_vm.strings},on:{"reset":_vm.reset}},[_c('ha-form-wizard',{ref:"wizard",attrs:{"type":_vm.wizardType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }